import { Spin } from 'antd';
import { Overlay, ProcessText } from 'components/Mailer/Mailer.styled';
import React, { FC, ReactElement } from 'react';

interface Props {
  message: string | undefined;
}

const Process: FC<Props> = ({ message }): ReactElement => (
  <Overlay>
    <Spin size="large" />
    <ProcessText>{message}</ProcessText>
  </Overlay>
);

export default Process;
